/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";

import Image from '../../../../containers/assets/pf5.png';

const CareerPathwayStep3 = () => (
  <OneVisualLayout
    section="CAREER PATHWAY"
    title="Supply Chain Management"
    paragraph1={(
      <Fragment>
        The supply chain operations discipline also plays a critical role and
        can be the difference of a company making a profit or a loss.
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        It's why Apple's massive success was not only due to Steve Jobs
        (the product manager guy), but also Tim Cook (the operations guy)
        who revamped the supply chain process to ensure that quality products
        were delivered to customers in a timely manner and at the lowest cost
        to Apple. <a href="#" onClick={e => e.preventDefault()}>Learn More</a><br />
        A broken supply chain that's widespread across industries, however, can drive
        inflation and make the overall cost of living painfully expensive for a society. <a href="#" onClick={e => e.preventDefault()}>Learn More</a>
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default CareerPathwayStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/career-pathway/step3.js